var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"div-torta"},[_c('Torta',{attrs:{"labels":this.labels,"data":this.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }